module.exports = __webpack_public_path__ + "static/notification-default.db047518.jpg";